import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, Observable, of} from "rxjs";
import {AddPropertyRequest} from "./pinhole.user.service";

@Injectable({
    providedIn: 'root'
})
export class PinholeLicenseService {

    constructor(private httpClient: HttpClient) {

    }

    findLicense(iid: string): Observable<Licenses | null> {
        return this.httpClient.get<Licenses>("/rest/admin/find_license/" + iid)
    }

    setLicense(request: AddLicenseRequest): Observable<any | null> {
        return this.httpClient.post(`/rest/admin/add_license`, request)
    }
}

export interface AddLicenseRequest {
    iid: string;
    durationDays: number;
}

export interface Licenses {
    readonly active: LicenseInfo;
    readonly serverAdded: LicenseInfo | null;
    readonly purchases: LicenseInfo[]
}

export interface LicenseInfo {
    readonly type: string;
    readonly expiration: Date;
    readonly additionalInfo: String
}